// Legacy Site serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'

export const SiteRecord = Immutable.Record({
  clientId: null,
  country: null,
  geo: null,
  id: null,
  name: '',
  pid: null,
  postcode: null,
  state: null,
  street_name: null,
  street_number: null,
  street_type: null,
  suburb: null,
  unit_number: null,
}, 'Site')

export const SiteFilterRecord = Immutable.Record({
  clientId: null,
})

export default function createSite(data) {
  return new SiteRecord(data)
}

export function filterSite(filter, site) {
  let ok = true

  if (filter.clientId) {
    ok = site.clientId === filter.clientId
  }

  return ok
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Site.js